import { downloadBlob } from '../../utils/data/utils';
import { trackUIInteraction } from '../../utils/analyticsEvents';
import { requestExcel } from '../actions/api/export';
import { selectCurrentMarketCode } from '../slices/intl';

export const requestExcelPendingListenerOptions = {
  actionCreator: requestExcel.pending,
  effect: (action, listenerApi) => {
    const { dispatch, getState } = listenerApi;
    const {
      meta: {
        arg: { catalogId, categoryId, includeItems },
      },
    } = action;
    const market = selectCurrentMarketCode(getState());
    trackUIInteraction('export_excel', {
      catalogId,
      categoryId,
      includeItems,
      market,
    });
  },
};

export const fileDownloadRequestFulfilledListenerOptions = {
  type: 'api/request/file/fulfilled',
  effect: (action) => {
    downloadBlob(action.payload);
  },
};
